import {getI18n, useTranslation} from "react-i18next";
import ls from "../../../../utils/ls";
import {useEffect} from "react";
import useLanguage from "../../../../hooks/useLanguage";

export default function LangMenus({ visible, onClose, style }) {
  const [lang, setLang] = useLanguage();
  let clickAway = null;
  
  const changeLang = (lang) => {
    setLang(lang, () => {
      onClose(false);
    });
  };
  
  useEffect(() => {
    clickAway = document.body.addEventListener('click', (e) => {
      if (e.target.id.indexOf('LANG_MENUS') == -1) {
        onClose(false);
      }
    });
    
    return () => {
      if (clickAway) {
        document.body.removeEventListener('click');
      }
    };
  }, []);
  
  return (
    <>
      <div id="LANG_MENUS"
           onClick={onClose}
           style={{ boxShadow: '0 2px 15px rgba(0,0,0,.3)', zIndex: 99, display: visible ? 'block' : 'none', ...style }}
           className="top-[150%] left-0 rounded-[5px] absolute bg-white overflow-hidden">
        <ul className="divide-[#eee] divide-y">
          {
            lang.map((item, i) => (
              <li id={`LANG_MENUS_${i}`}
                  onClick={() => changeLang(item.lang)}
                  className="px-[34px] w-[150px] py-[12px] cursor-pointer hover:bg-[#eee]"
                  key={i}>
                {item.name}
              </li>
            ))
          }
        </ul>
      </div>
    </>
  );
}
